
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program-promotion",
      function () {
        return require("private-next-pages/program-promotion.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program-promotion"])
      });
    }
  